import { ensureCsrfToken, requestJson } from "./apiClient";

import { API_BASE_URL } from "../config/apiBaseUrl.js";

async function parseAuthResponse(response) {
  let body = null;

  try {
    body = await response.json();
  } catch {
    body = null;
  }

  return body;
}

export async function login(email, password) {
  const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ email, password }),
  });

  const body = await parseAuthResponse(response);

  if (!response.ok) {
    const error = new Error(
      body?.message || "Invalid email or password."
    );
    error.status = response.status;
    error.body = body;
    throw error;
  }

  return body;
}

export async function logout() {
  await ensureCsrfToken();
  return requestJson("/api/auth/logout", {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export async function getAuthConfig() {
  const response = await fetch(`${API_BASE_URL}/api/auth/config`, {
    credentials: "include",
  });

  const body = await parseAuthResponse(response);

  if (!response.ok) {
    return { success: false, googleAuthEnabled: false, githubAuthEnabled: false };
  }

  return body;
}

export function getGoogleSignInUrl(returnTo = "") {
  const params = new URLSearchParams();
  if (returnTo) {
    params.set("returnTo", returnTo);
  }

  const query = params.toString();
  return `${API_BASE_URL}/api/auth/google${query ? `?${query}` : ""}`;
}

export function getGitHubSignInUrl(returnTo = "") {
  const params = new URLSearchParams();
  if (returnTo) {
    params.set("returnTo", returnTo);
  }

  const query = params.toString();
  return `${API_BASE_URL}/api/auth/github${query ? `?${query}` : ""}`;
}

export async function getCurrentUser() {
  const response = await fetch(`${API_BASE_URL}/api/auth/me`, {
    credentials: "include",
  });

  const body = await parseAuthResponse(response);

  if (response.status === 401) {
    return { success: false, user: null, status: 401 };
  }

  if (!response.ok) {
    const error = new Error(body?.message || "Unable to load current user.");
    error.status = response.status;
    error.body = body;
    throw error;
  }

  return body;
}
